import React from 'react';
import "./styles.css";

const Math = () => {
  const projects = [
    {
      id: 1,
      title: 'Introduction to Calculus',
      description:
        'Rarely in real economic data would you find a perfectly linear relationship between two variables, x and y. If you need to find the rate of change when dealing with a non-linear curve, or if you need to know the area under a curve representing non-linear data, you would need to know differential and integral calculus.',
      file: '/presentations/Introduction to Calculus/Introduction to Calculus.html',
    },
    {
      id: 2,
      title: 'Deriving the Quadratic Formula',
      description:
        'When working with differential and integral calculus, knowing how to derive the standard form quadratic formula is key.',
      file: '/presentations/Deriving the Quadratic Formula/Deriving the Quadratic Formula.html',
    },
    {
      id: 3,
      title: "Using Pascal's Triangle for Binomial Expansion",
      description:
        "Using Pascal's Triangle for Binomial Expansion is a useful tool when working with quadratic equations.",
      file: '/presentations/Using Pascals Triangle for Binomial Expansion/Using Pascals Triangle for Binomial Expansion.html',
    },
    {
      id: 4,
      title: 'The Golden Ratio',
      description:
        'Did you know that executives who know theory use the golden ratio to predict market trends? This is especially true in the case of Fibonacci Arcs, which are used to predict call and put thresholds in options trading.',
      file: '/presentations/The Golden Ratio/The Golden Ratio.html',
    },
  ];

  return (
    <div className="container">
      {projects.map((project) => (
        <div key={project.id} className="project-item">
          <h1>{project.title}</h1>
          <p>{project.description}</p>
          <a
            href={project.file}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Visit ${project.title}`}
          >
            View Presentation
          </a>
        </div>
      ))}
    </div>
  );
};

export default Math;